import { API_ADDRESS_LOCAL } from "../../api/api-addr/l";
import { IContextData } from "./common";

const footer = [
    [
        {"route":"/applicant/learn/about", "caption": "title_aboutmpt"},
        {"route":"/contact", "caption": "title_contactus"},
        {"route":"/news", "caption": "title_news"},
        {"route":"/testadmin/learn/access_accomm", "caption": "title_acc_amm"},
        {"route":"/testadmin/learn/tech", "caption": "title_techreq"}
    ],
    [
        {"route":"/applicant/learn/faq", "caption": "title_faq_app"},
        {"route":"/testadmin/learn/faq", "caption": "title_faq_adm"},
        {"route":"/applicant/learn/about:for_me", "caption": "title_teach_app"},
        {"link" :"faculties_website", "caption": "title_foe"},
        {"link" :"oct_website", "caption": "title_oct_full"}
    ],
    [
        {"route":"/privacy", "caption": "title_privacy"},
        {"route":"/legal", "caption": "title_legal"}
    ],
    []
  ]

const apiAddress = (hostname:string) => {
    switch(hostname){
      case 'xqc1.mathproficiencytest.ca': return 'https://xqc1-api.mathproficiencytest.ca';
      // case 'qc1.mathproficiencytest.ca': return 'https://api-eassessment.vretta.com';
      case 'qc1.mathproficiencytest.ca': return 'http://localhost:3030';
      // case 'qc1.mathproficiencytest.ca': return 'https://qc1-api.mathproficiencytest.ca';
      // case 'qc3.mathproficiencytest.ca': return 'https://qc3-api.mathproficiencytest.ca';
      case 'qc3.mathproficiencytest.ca': return 'http://localhost:3030';
      // case 'localhost':  return 'https://api-eassessment.vretta.com';
      // case 'localhost': return API_ADDRESS_LOCAL;
      // case 'qc3.mathproficiencytest.ca':
      // case 'localhost':
      case 'mpt-admin.vretta.com': 
        return 'https://mpt-admin-api.vretta.com'
      case 'mpt-admin-auth.vretta.com': 
        return 'https://mpt-admin-auth-api.vretta.com'
      case 'mpt-admin-qc.vretta.com': return 'https://mpt-admin-qc-api.vretta.com'
      case 'testcompetencesmaths.ca':
      case 'mathproficiencytest.ca':
      case 'www.testcompetencesmaths.ca':
      case 'www.mathproficiencytest.ca':
      default: return 'http://localhost:3030';
    }
  }

export const MPT:IContextData = {
    id: 'MPT',
    homepageRoute: '/mpt-launch',
    loginRoute: '/en/general/login/true',
    brandName: 'brand_short',
    defaultTimezone: 'America/Toronto',
    logo: '',
    footer,
    apiAddress,
    siteFlags: {
      BREADCRUMB_MENU: true,
      BOOKING_POLICY_STATS: true,
      IS_TEXT_ALIGNMENT_HIDDEN: true,
      IS_ADVANCED_FRAMEWORK_CONFIG_HIDDEN: true,
      ALLOW_TEMPLATE_AUTHOR: true,
    },
    siteText: {
      copyright: 'title_copyright',
      supportEmail: 'support@mathproficiencytest.zendesk.com',
      supportPhone: '+1 (877) 960-0127',
      my_inst: 'ta_my_faculty_lbl',
      my_inst_admin: 'lbl_inst_mngr_you',
    },
    hosts: [
        // 'localhost:4200',
        'mathproficiencytest.ca',
        'testcompetencesmaths.ca',
        'www.mathproficiencytest.ca',
        'www.testcompetencesmaths.ca',
        'qc3.mathproficiencytest.ca',
        'qc1.mathproficiencytest.ca',
    ]
}
